import {
  Directive,
  Input,
  OnChanges,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { DelightedSubProperties } from '@interfaces/delighted-sub-properties.interface';
import { DelightedService } from './delighted.service';
import { Results } from '@interfaces/results.interface';
import * as _ from 'lodash';
import { SearchParamType } from '@interfaces/search-param-type.interface';

@Directive({
  selector: '[appDelightedTrigger]',
})
export class DelightedDirective implements OnChanges, OnDestroy {
  @Input() delightedDelay: number = null;
  @Input() delightedQuestionProductName: string = null;
  @Input() delightedResults: Results;
  @Input() delightedSearchType: SearchParamType;
  @Input() delightedSearchTerm: string;
  @Input() delightedFilters: boolean;
  @Input() delightedSurveyType: string;

  private defaultDelay: number = 0;
  private filterMatches = /mat-|more-|reset|ng-/;

  constructor(private service: DelightedService) {}

  @HostListener('click', ['$event'])
  onClick(event) {
    if (this.filterSelection(event)) {
      this.triggerSurvey();
    }
  }

  ngOnChanges() {
    this.triggerSurvey();
  }

  ngOnDestroy() {
    this.service.reset('csat');
  }

  private triggerSurvey(): void {
    if (this.isReady()) {
      this.service.activateSurvey(
        { properties: this.properties() },
        this.delightedResults || {},
        this.requestedDelay(),
        this.delightedSurveyType
      );
    }
  }

  private filterSelection(event): boolean {
    return (
      this.delightedFilters &&
      _.some(event.target['classList'], (el) => this.filterMatches.test(el)) &&
      !_.some(event.target['classList'], (el) => /icon-map/.test(el))
    );
  }

  private isReady(): boolean {
    // only the search term input changes after initialization
    return !!(
      typeof this.delightedSearchTerm === 'undefined' ||
      this.delightedSearchTerm
    );
  }

  private properties(): DelightedSubProperties {
    const out = {} as DelightedSubProperties;

    if (this.delightedQuestionProductName) {
      out.questionProductName = this.delightedQuestionProductName;
    }

    if (this.delightedSearchType) {
      out.searchType = this.delightedSearchType;
    }

    if (this.delightedSearchTerm) {
      out.searchTerm = this.delightedSearchTerm;
    }

    return out;
  }

  private requestedDelay(): number {
    return this.delightedDelay === null
      ? this.defaultDelay
      : this.delightedDelay;
  }
}
